export const GET_ORDER_DETAILS_START = 'ORDER_DETAILS/GET ORDER DETAILS START';
export const GET_ORDER_DETAILS_SUCCESS =
  'ORDER_DETAILS/GET ORDER DETAILS SUCCESS';
export const GET_ORDER_DETAILS_FAILED =
  'ORDER_DETAILS/GET ORDER DETAILS FAILED';

export const GET_CUSTOM_ITEMS_START = 'CUSTOM_ITEMS/GET CUSTOM ITEMS START';
export const GET_CUSTOM_ITEMS_SUCCESS = 'CUSTOM_ITEMS/GET CUSTOM ITEMS SUCCESS';
export const GET_CUSTOM_ITEMS_FAILED = 'CUSTOM_ITEMS/GET CUSTOM ITEMS FAILED';
